import {baseRequestService} from "../base.ts";

export const eventsEventIdAirportsAirportIdDelete = (eventId: string, airportId: string) => baseRequestService({
    url: `/events/${eventId}/airports/${airportId}`,
    method: 'DELETE',
})